import { render, staticRenderFns } from "./acctSecurityDc.vue?vue&type=template&id=709b16c5&scoped=true"
import script from "./acctSecurityDc.vue?vue&type=script&lang=js"
export * from "./acctSecurityDc.vue?vue&type=script&lang=js"
import style0 from "./acctSecurityDc.vue?vue&type=style&index=0&id=709b16c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b16c5",
  null
  
)

export default component.exports